export class Range {
  min: number;
  max: number;

  constructor(_min: number, _max: number) {
    this.min = _min;
    this.max = _max;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/common/dob/dob.range.ts